<template>
  <v-layout row>
    <v-snackbar v-model="snackbar" top light>
      <span>Agregada nueva modificación de la ficha</span>
      <span style="padding-left: 5px"><a @click="goDraft" class="orange--text">(Ir al Draft)</a></span>
      <v-btn color="primary" flat icon @click="snackbar = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>

    <v-toolbar class="toolbar-element" light absolute flat height="90em">
      <template v-if="$vuetify.breakpoint.smAndUp">
        <v-toolbar-title class="toolbar-title"><img :src="clubLogo" height="45" class="logo"></v-toolbar-title>
        <v-toolbar-title class="toolbar-title ml-1"><span>{{ clubName }}</span></v-toolbar-title>
        <v-spacer></v-spacer>
      </template>
      <v-flex :xs4="$vuetify.breakpoint.smAndUp">
        <v-text-field v-model="search" solo light append-icon="search" label="Buscar por nombre de criterio"
                      single-line hide-details flat></v-text-field>
      </v-flex>
    </v-toolbar>

    <v-content class="body-content">
      <div class="breadcumbs-element">
        <span>{{ subarea.nombre }} </span>
        <span disabled class="mx-1">></span>
        <span disabled> {{ (subarea.hasOwnProperty('area')) ? subarea.area.nombre : ''}}</span>
        <br>
        <div style="display: flex; justify-content: center;">
          <v-btn light @click="goDraft" large color='rgb(255 214 0)' class="draft-button" v-if="$store.getters.hasDraftInProgress">
      <v-icon  color="black" class="icon-build">error_outline</v-icon>
      <span v-if="$store.getters.hasDraftInProgress">Haga <b>click aquí</b> para dirigirse a la <b>actualización en curso</b> y enviar los cambios realizados en la ficha.</span>
    </v-btn>
        </div>

      </div>
      <v-content class="body-content-secondary">
        <v-layout row wrap>
          <template v-for="criterioOrRepo in sortedCriteriosRepos">
            <v-flex xs12 class="criterio-element table-element" v-if="repositories.includes(criterioOrRepo)" :key="criterioOrRepo.theOrder">
              <div class="criterio-title">{{ criterioOrRepo.criterionDefinition.nombre }}
                <v-tooltip bottom v-if="criterioOrRepo.criterioRepoDraft !== '' && allowed && criterioOrRepo.isModifiable">
                  <v-icon small color="warning darken-1" class="status-icon" slot="activator">update</v-icon>
                  <span>Actualización en curso</span>
                </v-tooltip>
                <v-tooltip bottom class="action-buttons" v-if="allowed && criterioOrRepo.isModifiable">
                  <v-btn small icon flat color="#293968" slot="activator">
                    <v-icon color="primary lighten-2" @click="openRepoCriterion(criterioOrRepo)">add_box</v-icon>
                  </v-btn>
                  <span>Agregar nueva entrada</span>
                  <RepoEdit v-if="showEditRepo"
                            :criterio="currentEditRepo"
                            :there-is-criterio-repo-draft="currentEditRepoIsDraft"
                            @hideDialog="hideEditRepo"
                            @updateRequerimiento="updateAfterRequest">
                  </RepoEdit>
                </v-tooltip>
              </div>
              <hr color="#96d8f7" class="divider-element">
            </v-flex>
            <v-flex xs12 px-4 pb-5 v-if="repositories.includes(criterioOrRepo)" :key="criterioOrRepo.pk">
              <CriterioRepositoryTable :repository="criterioOrRepo"></CriterioRepositoryTable>
            </v-flex>
            <v-flex v-if="criterios.includes(criterioOrRepo)"
                    :class="[criterioOrRepo.layout ? criterioOrRepo.layout : 'xs6']" class="criterio-element"
                    v-show="showCriterio(criterioOrRepo)" :key="criterioOrRepo.pk">
              <div class="criterio-title">
                {{ criterioOrRepo.nombre }}
                <v-tooltip bottom v-if="$store.state.permissions.canViewVencimientos && isExpired(criterioOrRepo)">
                  <v-icon small color="red lighten-1" class="status-icon" slot="activator">error</v-icon>
                  <span>Venció el {{criterioOrRepo.expiration.date}}</span>
                </v-tooltip>
                <v-tooltip bottom v-if="$store.state.permissions.canViewVencimientos && isInTerm(criterioOrRepo)">
                  <v-icon small color="red lighten-1" class="status-icon" slot="activator">calendar_today</v-icon>
                  <span>Vence el {{criterioOrRepo.expiration.date}}</span>
                </v-tooltip>
                <v-tooltip bottom v-if="$store.state.permissions.canViewVencimientos && isWithoutTerm(criterioOrRepo)">
                  <v-icon small color="orange lighten-1" class="status-icon" slot="activator">warning</v-icon>
                  <span>Vencimiento sin plazo definido</span>
                </v-tooltip>
              </div>
              <hr color="#96d8f7" class="divider-element">
              <template v-for="requerimiento in criterioOrRepo.requerimientos">
                <template v-if="canViewRequirement(requerimiento)">
                  <v-layout row wrap class="requerimiento-element" :key="requerimiento.pk">
                    <v-flex xs12 md8 lg10>
                      <v-tooltip bottom v-if="requerimiento.isInDraft && allowed">
                        <v-icon small color="warning darken-1" class="status-icon" slot="activator">update</v-icon>
                        <span>Actualización en curso</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template slot="activator">
                          <span class="requerimiento-title"
                                v-if="requerimiento.showName">{{ requerimiento.nombre }}: </span>
                          <span class="requerimiento-data">{{ getFormattedData(requerimiento) }}</span>
                        </template>
                        <span>Última modificación: {{ requerimiento.modified }}</span>
                      </v-tooltip>
                    </v-flex>
                    <v-flex xs12 md4 lg2>
                      <RequerimientoActions :requerimiento="requerimiento" :allowed="allowed"
                                            @updateRequerimiento="updateAfterRequest">
                        <v-spacer></v-spacer>
                      </RequerimientoActions>
                    </v-flex>
                  </v-layout>
                  <div :key="'gallery'+requerimiento.pk" v-if="requerimiento.adjuntos.length">
                    <GallerySlider :attachments="requerimiento.adjuntos" :layout="criterioOrRepo.layout"
                                   padding="px-3 mb-4"></GallerySlider>
                  </div>
                  <hr class="divider-element dotted-hr" :key="'hr' + requerimiento.pk">
                </template>
              </template>
            </v-flex>
          </template>
        </v-layout>
      </v-content>
    </v-content>
  </v-layout>
</template>

<script>
import RepoEdit from '../components/RepoEdit'
import RequerimientoActions from '../components/RequerimientoActions'
import CriterioRepositoryTable from '../components/CriterioRepositoryTable'
import GallerySlider from '../components/GallerySlider'
import Constants from '../../../common/constants'
import _ from 'lodash'

export default {
  components: {
    RequerimientoActions,
    CriterioRepositoryTable,
    GallerySlider,
    RepoEdit
  },

  data () {
    return {
      subarea: {},
      criterios: [],
      repositories: [],
      criteriosOrRepos: [],
      showEditRepo: false,
      currentEditRepo: null,
      currentEditRepoIsDraft: false,
      allowed: false,
      snackbar: false,
      search: ''
    }
  },

  computed: {
    sortedCriteriosRepos: function () {
      return _.orderBy(this.criteriosOrRepos, 'theOrder')
    },
    filteredCriterios () {
      return this.filterArray(this.criterios, '')
    },
    filteredRepositories () {
      return this.filterArray(this.repositories, 'criterionDefinition')
    },
    clubName () {
      return this.$store.state.club
    },
    clubLogo () {
      return this.$store.state.icon
    }
  },

  methods: {
    fetchClubData () {
      this.axios
        .get(`ficha/${this.$route.params.id}`)
        .then(response => {
          this.allowed = response.data.allowedEdit
          this.setInitialValues(response.data)
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    fetchClubDataSaf () {
      this.axios
        .get(`ficha/clubes/${this.$route.params.idClub}/${this.$route.params.idSubarea}`)
        .then(response => {
          this.allowed = false
          this.setInitialValues(response.data)
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    fetchData () {
      if (this.$store.getters.hasFocusFicha || this.$route.name === 'fichaClub') {
        if (this.$route.params.idClub !== this.$store.state.fichaId) {
          this.$store.dispatch('fetchFichaClub', this.$route.params.idClub)
        }
        this.fetchClubDataSaf()
      } else {
        this.fetchClubData()
      }
    },
    updateAfterRequest (response) {
      this.snackbar = true
      if (response.status === 204) {
        this.$store.state.draft = null
      } else {
        this.$store.commit('setDraft', response.data.draft)
        if (response.data.hasOwnProperty('repoUpdated')) {
          this.updateRepo(response.data.repoUpdated)
        }
      }
    },
    updateRepo (repoUpdated) {
      for (let index in this.repositories) {
        const repository = this.repositories[index]
        if (repository.pk === repoUpdated.pk) {
          this.$set(this.repositories, index, repoUpdated)
          this.criteriosOrRepos = this.criterios.concat(this.repositories)
          break
        }
      }
    },
    goDraft () {
      this.$router.push({ name: 'draft' })
    },
    setInitialValues (data) {
      this.subarea = data.subarea
      this.criterios = data.criterios
      this.repositories = data.repositories
      this.criteriosOrRepos = data.criterios.concat(data.repositories)
      this.$store.commit('setActiveArea', this.subarea.area.pk)
      this.$store.commit('setActiveSubarea', this.subarea.id)
      window.scroll(0, 0)
    },
    removeAccents (str) {
      return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    },
    filterArray (array, property) {
      if (!array.length) return []
      return array.filter(criterio => {
        let nombre = (criterio.hasOwnProperty(property)) ? criterio[property].nombre : criterio.nombre
        return this.removeAccents(nombre).match(new RegExp(this.removeAccents(this.search), 'i'))
      })
    },
    isExpired (criterio) {
      if (criterio.expiration.hasOwnProperty('allStatus')) {
        return criterio.expiration.allStatus.isExpired
      }
      return false
    },
    isInTerm (criterio) {
      if (criterio.expiration.hasOwnProperty('allStatus')) {
        return criterio.expiration.allStatus.isInTerm
      }
      return false
    },
    isWithoutTerm (criterio) {
      if (criterio.expiration.hasOwnProperty('allStatus')) {
        return criterio.expiration.allStatus.isWithoutTerm
      }
      return false
    },
    getFormattedData (requirement) {
      if (requirement.tipo === Constants.REQUERIMIENTO_HAS_BOOLEAN) {
        return requirement.data ? 'Sí' : 'No'
      }
      return requirement.data
    },
    showOptionalRequirement (requirement) {
      if (!requirement.optional) return true
      return (requirement.data || requirement.adjuntos.length)
    },
    canViewRequirement (requirement) {
      return this.allowed || this.showOptionalRequirement(requirement)
    },
    showCriterio (criterio) {
      let hasCompletedRequirement = criterio.requerimientos.some(req => {
        return (req.data !== null) || req.adjuntos.length
      })
      let searchingCriterio = this.filteredCriterios.includes(criterio)
      return searchingCriterio && hasCompletedRequirement
    },
    openRepoCriterion (repo) {
      if (repo.criterioRepoDraft !== '') {
        this.axios
          .get(`repository/criterion/${repo.criterioRepoDraft}`)
          .then((response) => {
            this.saving = false
            this.showEditRepo = true
            this.currentEditRepo = response.data.criterioRepoDraft
            this.currentEditRepoIsDraft = true
          })
          .catch(error => {
            this.saving = false
            this.$store.commit('setErrorMsg', error)
          })
      } else {
        this.axios
          .post('repository/criterion/new', { criterion_definition: repo.criterionDefinition.id })
          .then((response) => {
            this.saving = false
            this.showEditRepo = true
            this.currentEditRepo = response.data.criterioAddedToRepo
            this.currentEditRepoIsDraft = false
          })
          .catch(error => {
            this.saving = false
            this.$store.commit('setErrorMsg', error)
          })
      }
    },
    deleteRepoCriterion () {
      this.axios
        .delete(`repository/criterion/remove/${this.currentEditRepo.pk}`)
        .then(() => {
          this.showEditRepo = false
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    hideEditRepo (isDraft) {
      if (!isDraft) {
        this.deleteRepoCriterion()
      } else {
        this.showEditRepo = false
      }
    }
  },

  created () {
    this.fetchData()
  },

  watch: {
    '$route.params.id' () {
      this.fetchData()
    },
    '$route.params.idSubarea' () {
      this.fetchData()
    }
  },

  beforeRouteLeave (to, from, next) {
    this.$store.commit('setActiveArea', -1)
    this.$store.commit('setActiveSubarea', -1)
    next()
  }
}
</script>

<style scoped>
  @font-face {
    font-family: SourceSansProLight;
    src: url(../../../assets/fonts/SourceSansPro-Light.ttf);
  }
  @font-face {
    font-family: SourceSansProRegular;
    src: url(../../../assets/fonts/SourceSansPro-Regular.ttf);
  }
  @font-face {
    font-family: SourceSansProSemiBold;
    src: url(../../../assets/fonts/SourceSansPro-SemiBold.ttf);
  }
  .body-content {
    padding: 0 !important;
    margin: 5.5em 0 0 0 !important;
  }
  .body-content-secondary {
    background-color: white;
    margin-top: 1em;
    padding: 0 0 0 0 !important;
    min-height: 38.5em;
  }
  .breadcumbs-element {
    font-size: 1.4em;
    font-family: SourceSansProRegular, sans-serif;
    color: #293968;
  }
  .criterio-element {
    font-size: 1.3em;
    font-family: SourceSansProSemiBold, sans-serif;
    color: #293968;
    padding: 0 0.4em 0 0.4em;
    margin-bottom: 2em;
  }
  .divider-element {
    margin: 0 1em 0 1em;
    padding: 0;
    border-top: 1px;
  }
  .criterio-title {
    padding: 0 1em 0 1em;
    margin: 1em 0 0.2em 0;
  }
  .requerimiento-element {
    padding: 0 1em 0 1em;
    margin: 0.6em 0 0.5em 0;
  }
  .requerimiento-title {
    font-size: 0.9em;
    font-family: SourceSansProSemiBold, sans-serif;
  }
  .requerimiento-data {
    font-size: 0.9em;
    font-family: SourceSansProRegular, sans-serif;
    white-space: pre-wrap;
  }
  .table-element{
    margin-bottom: 1em;
  }
  .dotted-hr {
    border-top: 1px dotted darkgray;
  }
  .status-icon {
    margin: 0 0.3em 0.1em 0.2em;
  }
  .logo {
    margin-top: 0.4em;
  }
</style>
